module.exports = __webpack_public_path__ + "media/images/stores7-43475e5f26dfcae05d1efd84e27ef15b.jpg";